import { useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { createFNVHashSync } from "../../authentication/utils";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

// An empty array means "no filter" — every eligible account is included.
export const DEFAULT_NET_WORTH_FILTER_STATE: string[] = [];

export const getNetWorthFilterStorageKey = (userId: string): string => {
  const hashedId = createFNVHashSync(userId);
  return `net_worth_filter_${hashedId}`;
};

export const useNetWorthFilterStorage = (userId: string) => {
  const storageKey = useMemo(
    () => getNetWorthFilterStorageKey(userId),
    [userId]
  );

  const [state, setState, removeValue] = useLocalStorage<string[]>(
    storageKey,
    DEFAULT_NET_WORTH_FILTER_STATE
  );

  return [state, setState, removeValue] as const;
};

export const useCurrentUserNetWorthFilterStorage = () => {
  const { currentUser } = useCurrentUser();
  const userId = currentUser?.id?.toString() || "";

  return useNetWorthFilterStorage(userId);
};
